class Collections {
    constructor() {
        let doc = document
        this.qsa = (s, o = doc) => o.querySelectorAll(s),
            this.qs = (s, o = doc) => o.querySelector(s)
        this.$body = document.querySelector('body')
        this.$nav_menu = document.querySelector('.nav-menu')

        
        this.colle = {
            $options: document.querySelector('.main-collections__options'),
            $filter: document.querySelector('.main-collections__filters'),
            $release: document.querySelector('.release-filter'),
            $grid: document.querySelector('.main-collections__grid'),
            $btn_grid: document.querySelector('.main-collections__options__icons .icon-grid'),
            $btn_list: document.querySelector('.main-collections__options__icons .icon-list'),
            $trg_sort: document.querySelectorAll('.sort-filter__trg'),
            $sort: document.querySelectorAll('.sort-filter'),
        }

        if(document.querySelectorAll('.sort-filter').length > 0) { this.controlSort() }
        if(document.querySelectorAll('.main-collections__grid').length > 0) { 
            this.changeGrid()
            this.tick()
        }

        // this.onFilter()
    }

    onFilter() {
        let that = this
        this.filter = {
            $inputs: this.qsa('.filter-group-display__list input[type=checkbox]')
        }

        this.filter.$inputs.forEach(el => {
            el.addEventListener('click', (e)=> {
                // e.preventDefault();
                // e.checked = true;
                
                    if (el.checked) {
                        let filterUrl = `${el.getAttribute('name')}=${el.getAttribute('value')}`
                        this.ajaxifyFilter(filterUrl)
                    }
            })
        })
    }
    
    
    ajaxifyFilter(url) {
        this.$colleGrid = document.querySelector('.main-collections__grid')
        let that = this
        let currentUrl = window.location
        let finalUrl  = null
        
        if (window.location.href.indexOf("filter") > -1) {
            finalUrl  = `${currentUrl}&${url}`
        }
        else { finalUrl  = `/collections/all?${url}` }
        // console.log(finalUrl)
        fetch(finalUrl).then(function (response) {
            return response.text();
        })
            .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');

                let $newCollec = doc.querySelector('.main-collections__grid')
                that.$colleGrid.replaceWith($newCollec)
                window.history.replaceState({}, '', `${finalUrl}`);


            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });

    }
    
    
    
    
    
    
    
    
    
    //? - =========================  CHANGE GRID  ========================= -//
    //? - =========================  CHANGE GRID  ========================= -//
    changeGrid(){
        let that = this
        this.colle.$btn_list.addEventListener('click', ()=> {

            that.colle.$btn_list.classList.add('grid-active')
            that.colle.$btn_grid.classList.remove('grid-active')
            that.colle.$grid.classList.add('grid-expand')
        })
        this.colle.$btn_grid.addEventListener('click', ()=> {
            that.colle.$btn_grid.classList.add('grid-active')
            that.colle.$btn_list.classList.remove('grid-active')
            that.colle.$grid.classList.remove('grid-expand')
        })
    }
    
    
    
    
    
    
    
    
    
    
    //? - =========================  OPEN SORT  ========================= -//
    //? - =========================  OPEN SORT  ========================= -//
    controlSort() {
        let that = this
        
        this.colle.$trg_sort.forEach(el => {
            el.addEventListener('click', ()=> {
                let thisIndex = [].indexOf.call(that.colle.$trg_sort, el);
                that.colle.$sort[thisIndex].classList.toggle('opened')
            })
        })
    }
    
    
    
    
    
    
    
    
    
    //? - =========================  tick  ========================= -//
    //? - =========================  tick  ========================= -//
    

    tick() {

        if (window.innerWidth > 1024) {
            let vh = window.innerHeight
            let nav_bar_height = this.$nav_menu.getBoundingClientRect().bottom
            let gap = this.colle.$options.getBoundingClientRect().bottom
            let release_top = this.colle.$release.getBoundingClientRect().top
            
            if(gap < nav_bar_height && release_top > vh ) {
                this.colle.$filter.style.transform = `translateY(${ nav_bar_height + (gap * -1)}px)`
            }
            else if(gap > nav_bar_height) {
                this.colle.$filter.style.transform = `translateY(${0}px)`
            }
        }


        window.requestAnimationFrame(() => {
            this.tick()
        })
    }
}

new Collections()